<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <g>
    <path class="cls-3" d="m74.05,19.64v7.31H16.02v-7.31c0-1.99,1.63-3.62,3.62-3.62h50.79c1.99,0,3.62,1.63,3.62,3.62Z"/>
    <path class="cls-3" d="m75.09,27.98H14.98v-8.35c0-2.57,2.09-4.66,4.66-4.66h50.79c2.57,0,4.66,2.09,4.66,4.66v8.35Zm-58.04-2.07h55.97v-6.28c0-1.43-1.16-2.58-2.59-2.58H19.64c-1.43,0-2.59,1.16-2.59,2.58v6.28Z"/>
  </g>
  <path class="cls-4" d="m70.43,75.09H19.64c-2.57,0-4.66-2.09-4.66-4.66V25.91h60.11v44.52c0,2.57-2.09,4.66-4.66,4.66ZM17.05,27.98v42.45c0,1.43,1.16,2.59,2.59,2.59h50.79c1.43,0,2.59-1.16,2.59-2.59V27.98H17.05Z"/>
  <rect class="cls-4" x="53.67" y="26.95" width="2.07" height="47.11"/>
  <rect class="cls-4" x="34.33" y="26.95" width="2.07" height="47.11"/>
  <g>
    <line class="cls-2" x1="16.02" y1="42.65" x2="74.05" y2="42.65"/>
    <rect class="cls-4" x="16.02" y="41.62" width="58.04" height="2.07"/>
  </g>
  <g>
    <line class="cls-2" x1="16.02" y1="58.35" x2="74.05" y2="58.35"/>
    <rect class="cls-4" x="16.02" y="57.32" width="58.04" height="2.07"/>
  </g>
  <g>
    <circle class="cls-1" cx="45.04" cy="50.5" r="15.2"/>
    <path class="cls-3" d="m45.04,67c-9.1,0-16.5-7.4-16.5-16.5s7.4-16.5,16.5-16.5,16.5,7.4,16.5,16.5-7.4,16.5-16.5,16.5Zm0-30.41c-7.67,0-13.91,6.24-13.91,13.91s6.24,13.91,13.91,13.91,13.91-6.24,13.91-13.91-6.24-13.91-13.91-13.91Z"/>
  </g>
  <g>
    <path class="cls-5" d="m43.22,44.07c-.13.05-.34.06-.67-.1l-.23-.11-.05-.28s-.12-.66-.19-1.37c-.15-1.38-.03-1.78.09-1.98.07-.11.18-.17.3-.17.19,0,.39.12.88.7.17.21.26.49.23.75-.14,1.11-.16,1.7-.13,1.84.11.36-.02.56-.08.62-.03.03-.08.07-.15.1Zm.23-.73s0,0,0,0c0,0,0,0,0,0Zm-.66-2.06s0,.08,0,.13c0-.04,0-.07.01-.11,0,0-.01-.01-.02-.02Z"/>
    <path class="cls-5" d="m43.04,44.39c-.14.1-.32.12-.47.15-.16.03-.41.06-.75.07-.55.01-1.38-.03-2.25-.34-1.44-.52-2.36-1.54-2.53-1.73-.15-.18-.2-.43-.12-.65.08-.22.28-.38.51-.42.49-.08,1.77-.21,3.05.25.94.34,1.63.84,1.96,1.12.22.18.41.37.56.54.11.13.36.43.24.77h0c-.04.12-.11.2-.2.25Zm-.29-.43h0s0,0,0,0Zm-4.34-1.54c.36.3.88.65,1.51.87.66.24,1.31.29,1.8.28-.37-.3-.91-.65-1.58-.89-.61-.22-1.23-.27-1.73-.27Z"/>
    <path class="cls-5" d="m48.75,57.75c-1.94.61-3.98-.14-4.86-1.8-.13-.24-.42-.33-.69-.22-.15.06-.27.18-.32.33-.05.14-.04.28.03.41,1.12,2.1,3.71,3.06,6.15,2.29.02,0,.03-.01.05-.02.13-.06.24-.16.3-.29.06-.13.07-.28.01-.41-.1-.25-.39-.38-.66-.29Z"/>
    <path class="cls-5" d="m49.32,60.48s-.03.01-.04.02c-3.17,1.28-6.81-.25-8.11-3.42-.54-1.33-.62-2.81-.2-4.18.38-1.26.32-2.6-.18-3.79v-.03c-.9-2.16-.03-4.57,1.93-5.38s4.28.29,5.17,2.45c0,.02.02.04.02.06.54,1.37,1.49,2.58,2.73,3.49h0c.92.67,1.63,1.59,2.07,2.65.64,1.55.63,3.25-.02,4.8-.64,1.53-1.84,2.72-3.37,3.35Zm-6.21-15.83c-1.43.59-2.05,2.4-1.38,4.03v.03c.61,1.41.68,3.01.23,4.5-.35,1.14-.29,2.38.17,3.49,1.08,2.64,4.11,3.91,6.76,2.85.01,0,.02,0,.04-.01,1.28-.53,2.28-1.52,2.81-2.79.54-1.29.55-2.71.01-4-.36-.88-.96-1.64-1.72-2.21-1.4-1.03-2.46-2.39-3.08-3.94,0-.02-.01-.03-.02-.05-.67-1.63-2.38-2.48-3.82-1.89Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "TotalProduceTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #115c72;
  }
  .cls-4 {
    fill: #59c5c7;
  }
  .cls-5 {
    fill: #b6dfcf;
  }
</style>